interface SpinnerProps {
  size?: number
  className?: string
}

export function Spinner({ size = 16, className }: SpinnerProps) {
  return (
    <span
      className={className ? `spinner ${className}` : 'spinner'}
      style={{ width: size, height: size }}
      role="status"
      aria-label="Загрузка"
    />
  )
}
